import React, {useEffect, useState} from 'react';
import {goToPage} from '../touristESimBlockSlice';
import {connect} from 'react-redux';
import BtnSubmit from '../../../Shared/Buttons/BtnSubmit';
const PackagePage = (props) => {
  const formSubmmit = () => {
    props.goToPage('paymentPage');
  };
  return (
    <div className='content'>
      <div className='tabs-container'>
        <div className='title'>informationPage</div>
        <div>Name</div>
        <div className='title'>{props.packageName.value}</div>
        <div>GB</div>
        <div className='title'>{props.gbLimit.value}</div>
        <div>SMS</div>
        <div className='title'>{props.smsLimit.value}</div>
        <div>Minutes</div>
        <div className='title'>{props.minuteLimit.value}</div>
      </div>
      <div className='button-wrapper'>
        <BtnSubmit text='to: PaymentPage' onclick={() => formSubmmit()} formid='PackagePage' />
      </div>
    </div>
  );
};
const mapStateToProps = (state) => {
  return {
    packageName: state.touristESimBlock.packageName,
    gbLimit: state.touristESimBlock.gbLimit,
    smsLimit: state.touristESimBlock.smsLimit,
    minuteLimit: state.touristESimBlock.minuteLimit,
    //other states
  };
};

const mapDispatchToProps = {
  goToPage,
};
export default connect(mapStateToProps, mapDispatchToProps)(PackagePage);
